import React from "react";


const ServiceOverview: React.FC = () => {
  return null; // No need to render anything, Summary is already shown in PortCreationFlow
};

export default ServiceOverview;
